// Use the canonical Breakpoint lockup from /public/brand/.
// Owned by the breakpointhq site; do NOT recolour, recompose, or substitute.

interface Props {
  variant?: "lockup" | "mark" | "wordmark";
  height?: number;
}

export function Wordmark({ variant = "lockup", height = 26 }: Props) {
  const src =
    variant === "mark"
      ? "/brand/mark-dark.svg"
      : variant === "wordmark"
        ? "/brand/wordmark-dark.svg"
        : "/brand/lockup-dark.svg";
  return <img src={src} alt="Breakpoint" className="lockup" style={{ height }} />;
}
